export const MENU_ITEMS = [
  { name: 'Home', page: 'home' },
  { name: 'Browse Cars', page: 'listings' },
  { name: 'How it Works', page: 'how-it-works' },
  { name: 'About Us', page: 'about' },
] as const;

/** Public contact details — use copy-to-clipboard in UI; avoid tel:/mailto: links to prevent OS "open other apps" prompts. */
export const CONTACT_INFO = {
  phone: '+1 (437) 887-1015',
  phoneE164: '+14378871015',
  email: 'Contact@sayaara.com',
  privacyEmail: 'privacy@sayaara.com',
} as const;

export const QUICK_LINKS = [
  { name: 'About Us', page: 'about' },
  { name: 'How It Works', page: 'how-it-works' },
  { name: 'Browse Cars', page: 'listings' }
] as const;

export const LEGAL_LINKS = [
  { name: 'Terms & Conditions', action: 'terms' },
  { name: 'Privacy Policy', action: 'privacy' },
  { name: 'FAQs', action: 'faqs' }
] as const;